"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaSignAndSendTransaction = void 0;
/** Name of the feature. */
exports.SolanaSignAndSendTransaction = 'solana:signAndSendTransaction';
//# sourceMappingURL=signAndSendTransaction.js.map